import React from 'react';
import { useViewMode } from '../../context/ViewModeContext';
import './ViewModeToggle.css';

/** The 2D | 3D switch. Every instance drives the same site-wide setting. */
export default function ViewModeToggle({ className = '', compact = false }) {
  const { mode, setMode } = useViewMode();
  return (
    <div className={`view-toggle ${compact ? 'view-toggle-compact' : ''} ${className}`} role="radiogroup" aria-label="Show pets in 2D or 3D">
      {[['2d', '2D'], ['3d', '3D']].map(([id, label]) => (
        <button
          key={id}
          type="button"
          role="radio"
          aria-checked={mode === id}
          className={`view-toggle-option ${mode === id ? 'active' : ''}`}
          onClick={() => setMode(id)}
        >
          {id === '3d' ? (
            <svg width="13" height="13" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path d="M8 1.5 14 5v6l-6 3.5L2 11V5l6-3.5Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
              <path d="M2 5l6 3.5L14 5M8 8.5V14.5" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
            </svg>
          ) : (
            <svg width="13" height="13" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <rect x="2.5" y="2.5" width="11" height="11" rx="2" stroke="currentColor" strokeWidth="1.6" />
            </svg>
          )}
          <span>{label}</span>
        </button>
      ))}
    </div>
  );
}
